import V2Title from '@/common/components/Feedback/V2Title';
import styles from './index.module.less';
import cs from 'classnames';
import { TaskMap } from './ts-config';
import { useMemo, useState, useContext } from 'react';
import { isNotEmptyAny } from '@lhb/func';
import AreaDetailDrawer from '@/common/components/business/AreaDetailDrawer';
import CircleTaskDetailMap from '../CircleTaskDetailMap';
import V2DetailGroup from '@/common/components/Feedback/V2DetailItem/Group';
import { Col, Form, Row } from 'antd';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';
import V2Form from '@/common/components/Form/V2Form';
import FormBusinessMode from '../../../../components/FormBusinessMode';
import { postTaskUpdate } from '@/common/api/expandStore/clusterAndDirect';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import FormFollowingStatus from '../../../../components/FormFollowingStatus';
import FormFranchisee from '@/common/components/Form/bussiness/FormFranchisee';
import FormEmergencyDegree from '../../../../components/FormEmergencyDegree';
import FormManager from '../../../../components/FormManager';
import V2FormDatePicker from '@/common/components/Form/V2FormDatePicker/V2FormDatePicker';
import dayjs from 'dayjs';
import UserInfoContext from '@/layout/context';
import { globalExpansionTaskAlias, globalFranchiseeAlias } from '@/common/utils/ways';
import { BusinessMode, franchiseeShortTitleForMode, TaskStatus } from '@/common/components/business/ExpandStore/ts-config';
import { clusterAndDirectTaskAssign } from '@/common/api/expandStore/clusterAndDirect';
import { useGlobalAlias } from '@/common/hook/useGlobalAlias';

interface CircleBasicInfoProps{
  taskDetail:any;
  chancePointList: any;
  title?: string; // 自定义标题
  className?: string;
  refresh?: any;
  isApproval?: boolean; // 是否是审核状态
  hideClusterDetail?: boolean;
  hideOperate?: boolean; // 是否禁止编辑（历史任务等场景）
}
interface DrawerData{
  open:boolean;
  id:string
}

/** 拓店任务：加盟+直营模板A-详情-基本信息 */
const CircleBasicInfo = (props:CircleBasicInfoProps) => {
  const [form] = Form.useForm();

  /** 获取开店区域别名 */
  const openingAreaAlias = useGlobalAlias('openingArea');

  const { taskDetail, chancePointList, title, className, refresh, isApproval, hideClusterDetail, hideOperate } = props;
  const [drawerData, setDrawerData] = useState<DrawerData>({ // 选址地图详情抽屉
    open: false,
    id: ''
  });
  const { tenantInfo: { globalAliasItemVOs } } = useContext(UserInfoContext); // 租户信息
  const franchiseeAlias = globalFranchiseeAlias(globalAliasItemVOs);
  const expansionTaskAlias = globalExpansionTaskAlias(globalAliasItemVOs);

  const basicTaskInfo = useMemo(() => {
    if (!isNotEmptyAny(taskDetail)) return {};
    const { modelClusterInfo, manager, emergencyDegree, emergencyDegreeName, targetProvinceName, targetCityName, targetDistrictName, signShopCount, expectDropInDate } = taskDetail;

    const updatedStandardFranchiseeId = taskDetail.standardFranchiseeId;
    const updatedStandardFranchiseeName = taskDetail.standardFranchiseeName;
    const updatedStandardFranchiseeUniqueId = taskDetail.standardFranchiseeUniqueId;

    form.setFieldsValue({
      businessMode: taskDetail.businessMode, // 业务模式
      standardFranchiseeId: updatedStandardFranchiseeId, // 加盟商id
      followingStatus: taskDetail.followingStatus, // 跟进状态
    });


    return {
      id: taskDetail.id,
      modelClusterName: modelClusterInfo?.modelClusterName,
      manager,
      emergencyDegree,
      emergencyDegreeName,
      targetAdress: `${targetProvinceName && targetProvinceName !== targetCityName ? targetProvinceName + '/' : ''}${targetCityName ? targetCityName + '/' : ''}${targetDistrictName ?? ''}`,
      signShopCount,
      expectDropInDate,
      standardFranchiseeId: updatedStandardFranchiseeId,
      standardFranchiseeName: (updatedStandardFranchiseeName || '-') + (updatedStandardFranchiseeUniqueId ? '/' + updatedStandardFranchiseeUniqueId : ''),
      followingStatus: taskDetail['followingStatus'],
      followingStatusName: taskDetail['followingStatusName'],
      businessModeName: taskDetail['businessModeName'],
      businessMode: taskDetail['businessMode'],
      standardFranchiseeUniqueName: taskDetail['standardFranchiseeUniqueName'],
    };
  }, [taskDetail]);

  const handleClickClusterName = () => {
    const modelClusterId = taskDetail?.modelClusterInfo?.modelClusterId;
    if (!modelClusterId) return;
    setDrawerData({
      open: true,
      id: modelClusterId
    });
  };

  /**
   * @description 加盟商字段标题
   * @param businessMode 【加盟+直营】拓店任务模板场景下【业务模式】字段值
   * @return 判断是否联营模式，需要特殊显示
   */
  const franchiseeTitleForMode = (businessMode) => {
    const isJoint = businessMode === BusinessMode.Joint;
    return isJoint ? '联营商姓名' : `${franchiseeAlias}姓名`;
  };

  /**
   * 设置detail item 值
   * @param key
   * @returns
   */
  const getDetailItemValue = (key) => {
    if (key === 'modelClusterName' && !hideClusterDetail) { // 所属商圈
      return <a className={'color-primary-dark'} style={{ color: '#2441B3' }} onClick={handleClickClusterName}>{basicTaskInfo[key] || '-'}</a>;
    } else if (key === 'emergencyDegreeName' && (basicTaskInfo[key] === '紧急' || basicTaskInfo[key] === '非常紧急')) { // 紧急度
      return <span style={{ color: 'red' }}>{(basicTaskInfo[key] || '-')}</span>;
    } else {
      return basicTaskInfo[key] || '-';
    }
  };

  /**
   * 设置detail item 是否能编辑
   * @param key
   * @returns
   */
  const getDetailItemAllowEdit = (key) => {
    const hasPermission = taskDetail.permissions?.find(item => item.event === 'standardTask:edit');
    if (!hasPermission) return false; // 如果是为空，则不能编辑
    if (isApproval || hideOperate) return false; // 如果是审核状态或禁用（历史任务等场景），则不能编辑

    if (key === 'manager') {
      // 待指派时才可选择开发经理
      return taskDetail?.status === TaskStatus.WaitAssign;
    } else if (key === 'businessModeName') {
      return true;
    } else if (key === 'standardFranchiseeName') {
      return true;
    } else if (key === 'emergencyDegreeName') {
      return true;
    } else if (key === 'expectDropInDate') {
      return true;
    } else if (key === 'followingStatusName' && ![4, 5].includes(+basicTaskInfo['followingStatus'])) { // 跟进状态
      return true;
    }
    return false;
  };

  /**
   * 信息编辑
   */
  const updateTaskInfo = async(field) => {
    try {
      const values = await form.validateFields();
      if (field === 'standardFranchiseeId' && !values[field]) {
        values[field] = 0;
      }
      const isFieldBusinessMode = field === 'businessMode';
      // 传可编辑的所有字段的值，如果不传，接口无法区分传了null和不传，会把全部没传的可编辑字段值都置为null
      const params: any = {
        businessMode: basicTaskInfo.businessMode,
        followingStatus: basicTaskInfo.followingStatus,
        emergencyDegree: basicTaskInfo.emergencyDegree,
        expectDropInDate: basicTaskInfo.expectDropInDate,
        standardFranchiseeId: isFieldBusinessMode ? null : basicTaskInfo.standardFranchiseeId, // 模式变更时，需要清空之前选择加盟商
        ...values,
      };
      const targetValue = params.standardFranchiseeId;
      // 防止多个DetailItem都是编辑的状态而且加盟商是编辑状态
      if (isNotEmptyAny(targetValue) && targetValue !== 0 && !(+targetValue)) {
        params.standardFranchiseeId = basicTaskInfo.standardFranchiseeId;
      }
      await postTaskUpdate({ id: basicTaskInfo['id'], ...params });
      V2Message.success('编辑成功');
      refresh?.();
    } catch (err: any) {
      if (err?.errorFields?.length) {
        V2Message.error(err?.errorFields[0].errors[0]);
      }
      throw err;
    }
  };

  /**
   * 设置detail item 编辑内容
   * @param key
   * @returns
   */
  const getDetailItemEditConfig = (key) => {
    if (isApproval) return undefined; // 如果是审核状态，则不能编辑
    if (key === 'manager') {
      return {
        formCom: <FormManager label='开发人员' placeholder='请选择开发人员' name='manager'/>,
        onCancel() {},
        onOK: async() => {
          const values = await form.validateFields();
          const val = values['manager'];
          if (!val) return;
          await clusterAndDirectTaskAssign({
            taskId: taskDetail?.id,
            assignAccountId: val
          });
          V2Message.success('指派成功');
          refresh?.();
        }
      };
    } else if (key === 'businessModeName') {
      return {
        formCom: <FormBusinessMode label='业务模式' placeholder='请选择业务模式' name='businessMode'/>,
        onCancel() {
          form.setFieldValue('businessMode', basicTaskInfo.businessMode);
        },
        onOK: async() => {
          await updateTaskInfo('businessMode');
        }
      };
    } else if (key === 'emergencyDegreeName') {
      return {
        formCom: <FormEmergencyDegree label='紧急度' placeholder='请选择紧急度' name='emergencyDegree'/>,
        onCancel() {
          form.setFieldValue('emergencyDegree', basicTaskInfo.emergencyDegree);
        },
        onOK: async() => {
          await updateTaskInfo('emergencyDegree');
        }
      };
    } else if (key === 'expectDropInDate') {
      return {
        formCom: <V2FormDatePicker label='期望落位日期' name='expectDropInDate' />,
        onCancel() {
          form.setFieldValue('expectDropInDate', dayjs(basicTaskInfo.expectDropInDate));
        },
        onOK: async() => {
          await updateTaskInfo('expectDropInDate');
        }
      };
    } else if (key === 'standardFranchiseeName') {
      const frname = franchiseeTitleForMode(basicTaskInfo.businessMode);
      const frShortName = franchiseeShortTitleForMode(basicTaskInfo.businessMode);
      return {
        formCom: <FormFranchisee
          label={frname}
          name='standardFranchiseeId'
          placeholder={`请输入${frname}`}
          createBtnTitle={`去创建${frShortName}`}
          allowClear
          extraParams={{
            businessMode: basicTaskInfo.businessMode,
          }}
        />,
        onCancel() {
          form.setFieldValue('standardFranchiseeId', basicTaskInfo.standardFranchiseeId);
        },
        onOK: async() => {
          // 解决onClick 之后没有选择直接保存的场景
          const targetValue = form.getFieldValue('standardFranchiseeId');
          if (isNotEmptyAny(targetValue) && !(+targetValue)) {
            form.setFieldValue('standardFranchiseeId', basicTaskInfo.standardFranchiseeId);
          }
          await updateTaskInfo('standardFranchiseeId');
        },
        onClick() {
          // 解决点击编辑按钮时，输入框先显示id，然后<FormFranchisee/> 组件里loadData完之后才回显label的问题
          form.setFieldValue('standardFranchiseeId', basicTaskInfo.standardFranchiseeName);
        }
      };
    } else if (key === 'followingStatusName' && ![4, 5].includes(+basicTaskInfo['followingStatus'])) { // 跟进状态
      return {
        formCom: <FormFollowingStatus
          disabled={[4, 5].includes(basicTaskInfo['followingStatus'])} // 如果是已确定、已开业不能修改
          label='跟进状态'
          placeholder='请选择跟进状态'
          name='followingStatus'
          isEdit/>,
        onCancel() {
          form.setFieldValue('followingStatus', basicTaskInfo.followingStatus);
        },
        onOK: async() => {
          await updateTaskInfo('followingStatus');
        }
      };
    }
    return undefined;
  };

  return <div className={cs(styles.basicWrapper, className || '')}>
    <div className={styles.basicInfo}>

      <div className={styles.basicMap}>
        <CircleTaskDetailMap
          businessDetail={taskDetail}
          chancePointList={chancePointList}
        />
      </div>

      <V2Title type='H2' divider text={title || `${expansionTaskAlias || '任务'}基本信息`} style={{ marginTop: '16px' }} />

      <V2Form form={form} validateTrigger={['onChange', 'onBlur']}>
        <V2DetailGroup>
          <Row gutter={16}>
            {
              Object.entries(TaskMap(franchiseeTitleForMode(basicTaskInfo.businessMode), basicTaskInfo['standardFranchiseeUniqueName'])).map(([key, label], index) => {
                // 如果是加盟商 并且 业务模式不是加盟模式，则加盟商隐藏
                if (key === 'standardFranchiseeName' && ![BusinessMode.Franchisee, BusinessMode.Joint].includes(basicTaskInfo['businessMode'])) {
                  return <></>;
                }
                if (key === 'modelClusterName') {
                  label = openingAreaAlias;
                }
                return <Col span={8} key={index}>
                  <V2DetailItem
                    label={label}
                    allowEdit={getDetailItemAllowEdit(key)}
                    value={getDetailItemValue(key)}
                    editConfig={ getDetailItemEditConfig(key) }/>
                </Col>;
              })
            }
          </Row>
        </V2DetailGroup>
      </V2Form>

    </div>
    <AreaDetailDrawer
      drawerData={drawerData}
      setDrawerData={setDrawerData}
      viewChanceDetail={false}
      showCollect={false}
    />
  </div>;

};

export default CircleBasicInfo;
